import type { GlobalState } from "little-state-machine";

export function updateState(state: GlobalState, payload: Partial<GlobalState>): GlobalState {
  return {
    ...state,
    ...payload,
    loginPageData: {
      ...state.loginPageData,
      ...payload.loginPageData,
    },
    developerSettings: {
      ...state.developerSettings,
      ...payload.developerSettings,
    },
  };
}

// function updateRedirectUrl(state, payload) {
//   return {
//     ...state,
//     loginPageData: {
//       ...state.redirectUrl,
//       ...payload,
//     },
//   };
// }
